export const about = {
  "about.title": "About Suji",
  "about.subtitle": "The leading platform to connect businesses with the best suppliers in Nigeria",
  "about.mission_title": "Our Mission",
  "about.mission_text1": "Suji is revolutionizing how businesses find and connect with suppliers in Nigeria. Our geo-located platform makes it easy to discover the best business partners across the country.",
  "about.mission_text2": "We believe in the power of the Nigerian economy and are committed to facilitating connections that drive local business growth.",
  "about.stat_suppliers": "Active suppliers",
  "about.stat_states": "States covered",
  "about.mission_image_alt": "Nigerian business professionals collaborating",
  "about.values_title": "Our Values",
  "about.values_subtitle": "The principles that guide our work and commitment to the Nigerian business community",
  "about.value_transparency_title": "Transparency",
  "about.value_transparency_text": "At SUJI, we take pride in providing clear and useful information to help you make the right decisions. Not all contacts are systematically verified, but we give you the tools and guidance to move forward with clarity. You remain in control of your decisions.",
  "about.value_access_title": "Accessibility",
  "about.value_access_text": "We make the Nigerian market simple and accessible to everyone. Entrepreneurs, traders, or investors, SUJI easily connects you to local opportunities. Nigeria becomes accessible, without complexity.",
  "about.value_efficiency_title": "Efficiency",
  "about.value_efficiency_text": "We save you time by pointing you in the right direction. Our goal: reduce your search efforts and accelerate your results. Less searching, more action.",
  "about.team_title": "Our Team",
  "about.team_subtitle": "Experts passionate about developing the Nigerian entrepreneurial ecosystem",
  "about.team_ceo": "CEO & Founder",
  "about.team_cto": "Technical Director",
  "about.team_cco": "Commercial Director",
  "about.our_leadership_label": "Our Leadership",
  "about.cta_title": "Join the Suji community",
  "about.cta_subtitle": "Whether you're a supplier or buyer, discover how Suji can transform your business",
  "about.cta_become_supplier": "Become a supplier",
  "about.cta_search_suppliers": "Search for suppliers",
  "about.add_business": "Add your business",
  "about.badge_story": "Our Story",
  "about.badge_mission": "Our Mission"
};

export default about;
